<div class="content">
  <div class="title-card">
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <h1 class="page-title">Configuration</h1>
    </div>
  </div>
  <app-settings [brandId]="selectedBrandId" [title]="settingsTitle"></app-settings>
  <br/>
  <div class="title-card">
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <h2 class="page-title">Brands</h2>
      <button mat-button class="tcb-button" (click)="add()" *ngIf="allowBrandCreate">
        Add Brand
      </button>
    </div>
  </div>
  <mat-card>
    <mat-list>
      <mat-list-item *ngFor="let brand of brands">
        <a [routerLink]="['/configuration/brand', brand.id]" matLine>{{brand.name}}</a>
        <button mat-icon-button [matMenuTriggerFor]="menu" *ngIf="allowBrandEdit || allowBrandDelete">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="delete(brand)" class="badge bg-danger color-white" *ngIf="allowBrandDelete">
            Delete
          </button>
        </mat-menu>
      </mat-list-item>
    </mat-list>
  </mat-card>
</div>
